import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";
import {GameCenterWidgetPlaceholder} from "./placeholders/game-center-widget.placeholder";

const GameCenterWidgetAsyncComponent = AsyncComponent(async () => import('./game-center-widget' /* webpackChunkName: "game-center-widget" */ ));

export const GameCenterWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory>
    <React.Suspense fallback={<GameCenterWidgetPlaceholder />}>
      <GameCenterWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
